import React__default from 'react';
import { BoundedContent } from '../bounded-content/bounded-content.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { StandardHeroWithNavContentBelow } from './standard-hero-with-nav-content-below.component.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const propTypes = {};
const StandardHeroWithNavContent = renderWithRef('StandardHeroWithNavContent', propTypes, (props, ref) => {
  return /*#__PURE__*/React__default.createElement(BoundedContent, _extends({
    ref: ref
  }, props), /*#__PURE__*/React__default.createElement(StandardHeroWithNavContentBelow, null, props.children));
});
export { StandardHeroWithNavContent };